(function($) {
	/**
	 * Create clipbord interaction links on document ready
	 * See: https://clipboardjs.com/
	 */
	$(function() {
		var clipboard = new ClipboardJS(".js-copy-link");
	});
})(jQuery);
